// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3i27Q","buttons":"SendReceipts_buttons__2Tbn1","email":"SendReceipts_email__264xT","bookApptTitle":"SendReceipts_bookApptTitle__YjtLN"};